"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const yup_1 = require("@hookform/resolvers/yup");
const react_hooks_1 = require("@framework/react-hooks");
const provider_test_id_1 = require("@framework/provider-test-id");
const buttons_1 = require("../buttons");
const prompt_1 = require("../prompt");
const on_form_state_change_1 = require("../on-form-state-change");
const input_registry_provider_1 = require("../input-registry-provider");
const FormWrapper = props => {
    const { children, initialValues, enableReinitialize = true, onSubmit, onFormStateChange, showButtons, showDebug, showPrompt, submitRequiresValidForm = true, submit, formSubmitButtonRef, formSubmitButtonProps = {}, innerRef, sx = [], validationSchema, testId, } = props;
    const resolver = validationSchema ? (0, yup_1.yupResolver)(validationSchema) : undefined;
    const [registeredInputs, setRegisteredInputs] = (0, react_1.useState)([]);
    const form = (0, react_hook_form_1.useForm)({
        mode: "all",
        defaultValues: initialValues,
        resolver,
    });
    const handleSubmit = async (data, e) => {
        e?.preventDefault();
        e?.stopPropagation();
        const values = form.getValues();
        await onSubmit(values, form);
    };
    const listener = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await form.handleSubmit(handleSubmit)(e);
    };
    (0, react_hooks_1.useDeepCompareEffect)(() => {
        if (enableReinitialize) {
            form.reset(initialValues, { keepDirtyValues: true });
        }
    }, [enableReinitialize, initialValues]);
    (0, react_1.useEffect)(() => {
        innerRef?.current?.addEventListener("submit", listener);
        return () => {
            innerRef?.current?.removeEventListener("submit", listener);
        };
    }, [innerRef?.current]);
    const testIdProps = testId ? { "data-testid": `${testId}-form` } : {};
    return ((0, jsx_runtime_1.jsx)(provider_test_id_1.TestIdProvider, { testId: testId, children: (0, jsx_runtime_1.jsx)(input_registry_provider_1.InputRegistryProvider, { registeredInputs: registeredInputs, setRegisteredInputs: setRegisteredInputs, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { height: "100%" }, children: (0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, { ...form, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { component: "form", onSubmit: form.handleSubmit(handleSubmit), sx: Array.isArray(sx) ? [...sx, { height: "100%" }] : [sx, { height: "100%" }], ref: innerRef, ...testIdProps, children: [showPrompt && (0, jsx_runtime_1.jsx)(prompt_1.PromptIfDirty, { visible: showPrompt }), children, (0, jsx_runtime_1.jsx)(buttons_1.FormButtons, { ref: formSubmitButtonRef, visible: showButtons, showDebug: showDebug, submit: submit, submitRequiresValidForm: submitRequiresValidForm, handleSubmit: form.handleSubmit(handleSubmit), formButtonProps: formSubmitButtonProps }), onFormStateChange ? (0, jsx_runtime_1.jsx)(on_form_state_change_1.OnFormStateChange, { onFormStateChange: onFormStateChange }) : null] }) }) }) }) }));
};
exports.FormWrapper = FormWrapper;
//# sourceMappingURL=index.js.map